import { put } from '@/services/put'
import { UpdateApplicationsApplicantBody } from '@/types/application/update-applicant'

export function updateApplicationsApplicant(applicationId: string, body: UpdateApplicationsApplicantBody) {
  return put<UpdateApplicationsApplicantBody, { id: string }>(`/applications/${applicationId}/update-applicant`, body)
}
